export enum DesktopProcessErrorCode {
    BITTIUM_EXAMINATION_DURATION_CANNOT_BE_FOURTEEN_DAYS = 'BITTIUM_EXAMINATION_DURATION_CANNOT_BE_FOURTEEN_DAYS',
    CANNOT_CLEAR_HOLTER_WITH_RECORDINGS = 'CANNOT_CLEAR_HOLTER_WITH_RECORDINGS',
    FAILED_TO_FETCH_HOLTER_CONFIGURATION_DATA = 'FAILED_TO_FETCH_HOLTER_CONFIGURATION_DATA',
    FAILED_TO_FIND_HOLTER_DRIVE = 'FAILED_TO_FIND_HOLTER_DRIVE',
    HOLTER_ALREADY_CONTAINS_RECORDING = 'HOLTER_ALREADY_CONTAINS_RECORDING',
    HOLTER_ALREADY_SET = 'HOLTER_ALREADY_SET',
    HOLTER_CONFIGURATION_DATA_INCOMPLETE = 'HOLTER_CONFIGURATION_DATA_INCOMPLETE',
    HOLTER_DEVICE_ECGSTATS_DOES_NOT_CONTAIN_SERIALNUMBER = 'HOLTER_DEVICE_ECGSTATS_DOES_NOT_CONTAIN_SERIALNUMBER',
    HOLTER_DEVICE_HAS_NO_ECGSTATS_FILE = 'HOLTER_DEVICE_HAS_NO_ECGSTATS_FILE',
    HOLTER_MUST_BE_PLUGGED_IN_TO_CONFIGURE_DEVICE = 'HOLTER_MUST_BE_PLUGGED_IN_TO_CONFIGURE_DEVICE',
    HOLTER_MUST_BE_PLUGGED_IN_TO_READ_RESULTS = 'HOLTER_MUST_BE_PLUGGED_IN_TO_READ_RESULTS',
    HOLTER_NOT_SET_BUT_CONTAINS_RECORDING = 'HOLTER_NOT_SET_BUT_CONTAINS_RECORDING',
    HOLTER_USAGE_ONLY_ON_WINDOWS = 'HOLTER_USAGE_ONLY_ON_WINDOWS',
    MULTIPLE_RECORDERS_ATTACHED = 'MULTIPLE_RECORDERS_ATTACHED',
    // Holter
    NO_HOLTER_PROCEDURE_PHASE_GIVEN = 'NO_HOLTER_PROCEDURE_PHASE_GIVEN',
    PREPARATION_VALUES_DONT_MATCH = 'PREPARATION_VALUES_DONT_MATCH',
    WRITING_CONFIG_TO_HOLTER_FAILED = 'WRITING_CONFIG_TO_HOLTER_FAILED',
}
